import { z } from 'zod';

import { UpdateRawRecord } from '../../../types/rawRecordFields';

const uuidValue = z.string().uuid();

export const requiredUuid = () => uuidValue;

export const optionalUuid = () =>
    z.union([uuidValue, z.literal(''), z.null()]).optional();

export const requiredString = () => z.string();

export const optionalString = () => z.string().nullable().optional();

export const requiredNumber = () => z.number();

export const optionalNumber = () => z.number().nullable().optional();

export const requiredBoolean = () => z.boolean();

export const optionalBoolean = () => z.boolean().nullable().optional();

export const createDeleteSchema = () =>
    z.object({
        id: requiredUuid(),
    });

export const createUpdateSchemaFromAdd = <T extends z.ZodObject>(
    addSchema: T,
    requiredFields: readonly string[] = ['id'],
): z.ZodType<UpdateRawRecord<z.infer<T> & { id: string }>> =>
    addSchema.partial().required({
        ...requiredFields.reduce((acc, field) => {
            acc[field] = true;
            return acc;
        }, {}),
    }) as unknown as z.ZodType<UpdateRawRecord<z.infer<T> & { id: string }>>;
